import React from 'react';
import Slider from 'react-slick';

const MultiCarousel = ({ children, slidesToShow, responsive }) => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 4000, // delay
    cssEase: 'linear',
    draggable: true,
    pauseOnHover: true,
    responsive
  };
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Slider {...settings}>{children}</Slider>;
};

export default MultiCarousel;

MultiCarousel.defaultProps = {
  slidesToShow: 5,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 2
      }
    }
  ]
};
